import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const CuratedButtonStyles = styled.div`
  .info-standard {
    display: flex;
    width: 100%;
  }

  .info-standard-chevron {
    margin-left: auto;
    align-self: center;
    padding-top: 10px;
    margin-right: -6px;
    padding-left: 7px;
  }

  .info-compact {
    display: none;
    width: 100%;
  }

  .info-compact-chevron {
    align-self: center;
    padding-top: 26px;
    margin-right: -6px;
    padding-left: 7px;

    img {
      position: absolute;
      padding-top: 43px;
    }
  }

  .info-compact-block {
    display: block;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .info-text {
    align-self: center;
    justify-content: center;
    text-align: center;
    display: flex;
  }

  .inner-button {
    align-items: center;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 70px;
    justify-content: flex-start;
    padding: 0 10px;
    text-align: left;
  }

  .icon-img {
    align-items: center;
    background-color: ${Colors.primary.claytonBlue.light};
    border-radius: 25px;
    display: flex;
    justify-content: center;
    margin-right: 10px;
    height: 48px;
    width: 48px;
    min-height: 48px;
    min-width: 48px;

    .icn {
      height: 30px;
      position: relative;
      width: 30px;
    }
  }

  .label.large {
    font-size: 12px;
  }

  p {
    line-height: 1.29;
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    &.three {
      .info-standard {
        display: none;
      }
      .info-compact {
        display: flex;
      }
      .inner-button {
        flex-direction: column;
        height: 100px;
      }
      .icon-img {
        margin: 9px 0;
        align-self: center;
      }
    }
  }

  @media screen and (min-width: 900px) {
    &.three {
      .info-standard {
        display: flex;
      }
      .info-compact {
        display: none;
      }
      .inner-button {
        flex-direction: row;
        height: 70px;
      }
      .icon-img {
        margin: 0;
        margin-right: 10px;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    &.four {
      .info-standard {
        display: none;
      }
      .info-compact {
        display: flex;
      }
      .inner-button {
        flex-direction: column;
        height: 100px;
      }
      .icon-img {
        margin: 9px 0;
        align-self: center;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    &,
    &.four,
    &.three,
    &.two,
    &.one {
      .info-standard {
        display: flex;
      }
      .info-compact {
        display: none;
      }
      .inner-button {
        flex-direction: row;
        height: 70px;
      }
      .icon-img {
        margin: 0;
        margin-right: 10px;
      }
    }
  }
`;
